<template>
	<div>
		<template v-if="mount">
			<div>
				<el-input :class="{penetrate:penetrate}" :value="value" readonly :disabled="disabled" :size="size"
					@click.native="preview">
					<box :readonly="readonly" :disabled="disabled" :ref="boxRef" :title="button.props.title"
						:index="button.props.index" :group="button.props.group" :width="button.props.width"
						:moduleName="button.props.moduleName" @submit="submit" :store="store" code="0"
						:popoverDisabled="true" slot="append" v-if="!disabled && !readonly" />
				</el-input>
				<!-- 				<box :readonly="readonly" :disabled="disabled" :ref="boxRef" :title="button.props.title"
					:index="button.props.index" :group="button.props.group" :width="button.props.width"
					:moduleName="button.props.moduleName" @submit="submit" :store="store" code="0"
					:popoverDisabled="true" /> -->
				<el-button type="text" style="position: absolute;right: -22px;"
					v-if="penetrate && !disabled && !readonly">
					<i class="el-icon-refresh" @click="refresh('main')" v-if="!refreshing"></i>
					<i class="el-icon-loading" v-else></i>
				</el-button>
			</div>

		</template>
		<template v-if="!mount">
			<template v-if="penetrate">
				<template v-if="formCreateInject">
					<el-input :class="{penetrate:penetrate}" :value="value" readonly :disabled="disabled" :size="size"
						@click.native="preview">
					</el-input>
				</template>
				<template v-else>
					<div class="flex"
						style="flex-direction: row;align-items: center;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;"
						v-if="penetrate">
						<el-tooltip :open-delay="500" transition="none" class="item" v-for="(item,index) in tag" :key="index" effect="dark" :content="item.content" placement="top-start">
							<el-tag size="mini" :type="item.type" effect="dark"
								style="margin-right: 2px;">{{item.value}}</el-tag>
						</el-tooltip>
						<el-tooltip :open-delay="500" transition="none" effect="dark" :content="value" placement="top-start">
							<el-link type="primary" style="font-size:12px;" @click="preview">{{value}}</el-link>
						</el-tooltip>
						
					</div>
				</template>
			</template>
			<template v-else>
				<span v-if="renderCell">{{value}}</span>
				<el-input :type="inputprops.type" v-else v-model="inputvalue" :readonly="readonly" :disabled="disabled"
					:size="size" @change="change"></el-input>
			</template>
		</template>

		<formwindow :formConfig="formModule" v-if="formwindowShow" @back="formBack" />
		<component ref="componentRef" :is="penetrateComponentConfig.component" v-bind="penetrateComponentConfig.props"
			v-if="penetrateComponentConfig" />
	</div>
</template>
<style scoped>
	.inputbutton {
		border-radius: 0px;
		box-sizing: border-box;
		border-left: 0px;
		position: relative;
		top: -1px;
		width: 29px;
		padding: 7px 0px;
	}
</style>
<script>
	import Store from '@/store/store.js'
	import router from '@_system/router'
	import inputBase from '@_system/components/base/input.js'
	import box from '@_system/components/formcomponents/common/box/index.vue'
	import penetrate from '@_system/components/base/mixins/penetrate/penetrate.js'
	export default {
		mixins: [inputBase, penetrate],
		props: {
			$router: {
				type: Object,
				default: () => {
					return router
				}
			},
			inputprops: {
				default: () => {
					return {
						type: 'text',
						rows: 2
					}
				}
			},
			renderOpts: {
				type: Object,
				default: () => {
					return null
				}
			},
			quote: {
				type: String,
				default: () => {
					return null
				}
			},
			table: {
				type: Object,
				default: () => {
					return null
				}
			},
			row: {
				type: Object,
				default: () => {
					return null
				}
			},
			column: {
				type: Object,
				default: () => {
					return null
				}
			},
			bindField: {
				type: String,
				default: () => {
					return ''
				}
			},
			penetrate: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			penetrateModule: {
				type: Object,
				default: () => {
					return null
				}
			},
			penetrateComponent: {
				type: Object,
				default: () => {
					return null
				}
			},
			mount: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			disabled: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			readonly: {
				type: Boolean,
				default: () => {
					return false
				}
			},
			moduleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			sourceModuleName: {
				type: String,
				default: () => {
					return ''
				}
			},
			button: {
				type: Object,
				default: () => {
					return null
				}
			},
			fieldsource: {
				type: String,
				default: () => {
					return ''
				}
			},
			islist: {
				type: Boolean,
				default: () => {
					return false
				}
			}
		},
		data() {
			return {
				inputvalue: null,
				refreshing: false,
				store: {},
				boxRef: 'box_' + Math.random(),
				formModule: {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 3,
					foreingKey: {},
					extra: {},

				},
				formwindowShow: false,
				windowType: 'window',
				win: null,
				tag: []

			}
		},
		created() {

		},
		mounted() {
			this.inputvalue = this.value
			this.store.input = this
			if (!this.islist && !this.$store) {
				this.$store = Store.store
			}
			this.rendertag()

			//console.log(this.table.$toolbar)
			// if (!this.$router) {
			// 	console.log(1,this.value)

			// }else{
			// 	console.log(2,this.value)
			// }
			// if(!this.row){
			// 	let rule = this.formCreateInject.api.getRule(this.formCreateInject.field)
			// 	let props = rule.props
			// 	props.$router = 
			// }
		},
		watch: {

			value(e) {
				this.inputvalue = e
				this.change(e)
			}
		},
		computed: {

		},
		methods: {
			rendertag() {
				if(this.row){
					let extend_tag = this.row.extend_tag ? this.row.extend_tag : []
					let tag = extend_tag.find((item) => {
						return item.field == this.column.field
					})
					if (tag) {
						this.tag = tag.tag
					}
				}
				//console.log(this.tag)

			},
			getBox() {
				return this.$refs[this.boxRef]
			},
			submit(e) {
				e.formCreateInject = this.formCreateInject
				this.$emit('submit', e)
			},
			refresh(type) {

				this.refreshing = true
				if (type == 'main') {
					let box = this.$refs[this.boxRef]
					let page = {
						pageSize: 20,
						currentPage: 1
					}
					let form = {}
					form[this.quote] = this.value
					box.list(page, form).then((res) => {
						if (res.list.length != 0) {
							box.submitwidthreflash(res.list[0])
							this.change(this.value)
						} else {
							this.$message.error('刷新失败，未查询到数据')
						}
						this.refreshing = false
					})
				} else {
					new Promise((resolve) => {
						this.$emit('buttonclick', {
							resolve: resolve
						})
					}).then(() => {
						this.refreshing = false
						this.change(this.value)
					})


				}


			},
			change(val) {
				if (val) {
					this.$emit('input', Object.hasOwn(val, 'value') ? val.value : val)
					this.$emit('change', Object.hasOwn(val, 'value') ? val.value : val)
				}
			},
			formBack() {
				this.formwindowShow = false
				this.formModule = {
					component: '',
					name: '',
					id: 0,
					show: false,
					controlltype: 1,
				}
			},
		},
		components: {
			box
		}
	}
</script>